const data = {
  id: 1,
  title: 'Listen and choose True / False',
  subTitle: '(Nghe và chọn Đúng/ Sai)',
  audioUrl: 'https://cloud.softech.vn/storage/Data/Sentences/60781.mp3',
  answers: [
    { id: 1, answer: 'False', isCorrect: false },
    { id: 2, answer: 'True', isCorrect: true },
  ],
  settings: {
    answers: {
      direction: 'horizontal',
      bulletType: 'none',
      // bulletType: 'character',
      // bulletType: 'number',
    },
  },
};

export default data;
